import { useEffect } from "react";
import "@/App.css";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";
import BookingProvider from "@/components/site/BookingProvider";

function App() {
  useEffect(() => {
    // IntersectionObserver to reveal sections on scroll
    const els = document.querySelectorAll(".mll-reveal, .mll-stagger");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="App bg-bone text-stone">
      <BookingProvider>
        <Landing />
      </BookingProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
